"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @param {string} parentTestId testId of parent component
 * @param {string} component Callee component's definition. Ex: Button
 * @param {string} testIdSuffix Describes callee component's feature/property. Ex: SelectPrice
 */
function getTestId(parentTestId, component, testIdSuffix) {
    return parentTestId ? parentTestId + "_" + component + (testIdSuffix ? "_" + testIdSuffix : "") : "";
}
exports.default = getTestId;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/utils/utils.js
// module id = 38
// module chunks = 8